<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="addEditModal"
        persistent
        max-width="500px"
      >
        <v-card>
          <form @submit.prevent="submitForm()">
            <v-card-title class="pb-0">
              <v-flex
                xs11
                sm10
                md10
              >
                <span class="headline">
                  {{ isUpdate ? 'Update Force Update' : 'Add New Force Update' }}
                </span>
              </v-flex>
              <v-flex
                xs1
                sm2
                md2
              >
                <v-btn
                  flat
                  @click="closeDialog()"
                  class="close"
                >
                  <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-layout wrap>
                <input
                  type="file"
                  ref="imageRef"
                  style="position: absolute; visibility: hidden; top: -9999999;"
                  accept="image/*"
                  @input="imageSelected()"
                >

                <v-flex xs12>
                  <div
                    class="image-upload"
                    style="width: 100%; height: 200px;"
                    :style="
                      form.imageUrl
                        ? `background-image: url(${form.imageUrl})`
                        : ''
                    "
                    @click="chooseImage()"
                  >
                    <div
                      :style="form.imageUrl ? 'display: none' : ''"
                      class="image-upload-icon text-center"
                    >
                      <i class="fa fa-cloud"></i>
                      <span class="d-block text-caption text--secondary">
                        Upload image
                      </span>
                    </div>
                  </div>
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    v-model.number="form.title"
                    label="Title"
                    :error-messages="errors.collect('Title')"
                    v-validate="'required'"
                    data-vv-name="Title"
                  />
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    v-model.number="form.description"
                    label="Description"
                    rows="3"
                    :error-messages="errors.collect('Description')"
                    v-validate="'required'"
                    data-vv-name="Description"
                  />
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    v-model.number="form.build_number"
                    label="Build Number"
                    type="number"
                    :error-messages="errors.collect('Build Number')"
                    v-validate="'required|numeric'"
                    data-vv-name="Build Number"
                  />
                </v-flex>

                <v-flex xs12>
                  <v-select
                    :items="operatingSystems"
                    v-model="form.operating_system"
                    :error-messages="errors.collect('Operating System')"
                    data-vv-name="Operating System"
                    label="Operating System*"
                    v-validate="'required'"
                  >
                  </v-select>
                </v-flex>

                <v-flex xs12>
                  <v-select
                    :items="types"
                    v-model="form.type"
                    :error-messages="errors.collect('Type')"
                    data-vv-name="Type"
                    label="Type*"
                    v-validate="'required'"
                  >
                  </v-select>
                </v-flex>
              </v-layout>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                style="height:auto"
                @click="closeDialog()"
                outline
                color="normal"
              >Cancel</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto; margin-right: 2%"
                outline
                color="success"
              >
                {{ isUpdate ? 'Save' : 'Add' }}
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios'
import swal from 'sweetalert'

export default {
  props: ['addEditModal', 'form', 'isUpdate'],

  data() {
    return {
      loading: false,
      operatingSystems: [
        { text: 'Android', value: 'android' },
        { text: 'iOS', value: 'ios' }
      ],
      types: [
        { text: 'Soft', value: 'soft' },
        { text: 'Hard', value: 'hard' }
      ]
    }
  },

  methods: {
    closeDialog() {
      this.$validator.reset()
      this.$emit('close')
    },

    chooseImage() {
      this.$refs.imageRef.click()
    },

    imageSelected() {
      const imageFile = this.$refs.imageRef.files[0]
      if (imageFile.type.includes('image/')) {
        this.form.image = imageFile
        this.form.imageUrl = URL.createObjectURL(imageFile)
        this.form.image_updated = true
      } else {
        swal({
          title: 'File type must be an image',
          text: '',
          icon: 'error',
          timer: 1500,
          buttons: false
        })
      }
    },

    submitForm() {
      let token = localStorage.getItem('access_token')

      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true

          let formData = new FormData()

          if (this.form.image) {
            formData.append('image', this.form.image)
          }

          formData.append('build_number', this.form.build_number)
          formData.append('title', this.form.title)
          formData.append('description', this.form.description)
          formData.append('operating_system', this.form.operating_system)
          formData.append('type', this.form.type)

          if (this.isUpdate) {
            formData.append('_method', 'put')
            Axios.post(`api/force-update/${this.form.force_update_id}`, formData, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                this.loading = false
                swal({
                  title: 'Updated successfully',
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch((error) => {
                this.loading = false
                swal('Error', error.response.data.message, 'error')
              })
          } else {
            Axios.post('api/force-update', formData, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                this.loading = false
                swal({
                  title: 'Added successfully',
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch((error) => {
                this.loading = false
                swal('Error', error.response.data.message, 'error')
              })
          }
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}

.image-upload-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.image-upload {
  border: 1px dashed #ccc;
  cursor: pointer;
  position: relative;
  background-position: center;
  background-size: cover;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/forceUpdate/addEdit.vue